import Vue from 'vue';
import VueMeta from 'vue-meta';
import VueSwal from 'vue-swal';
import App from './App.vue';
import store from './store';
import './registerServiceWorker';
import './firebase';
import './vee-validate';

Vue.use(VueMeta);
Vue.use(VueSwal);

Vue.config.productionTip = false;

new Vue({
  store,
  render: h => h(App),
}).$mount('#app');
